import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  OTPInput: {
    width: "48px",
    height: "48px",
    textAlign: "center",
    borderRadius: "4px",
    fontSize: "18px",
    outline: "none",
    transition: "border-color 0.2s",
  },
}));

const OTPInput = ({ error, onOtpChange, resetOtp }) => {
  const { classes, cx } = useStyles();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);

  useEffect(() => {
    if (resetOtp) {
      const newOtp = new Array(6).fill("");
      setOtp(newOtp);
      onOtpChange && onOtpChange("");
      // Focus the first input
      inputRefs.current[0]?.focus();
    }
  }, [resetOtp, onOtpChange]);

  // Call onOtpChange whenever otp changes
  useEffect(() => {
    const otpString = otp.join("");
    onOtpChange && onOtpChange(otpString);
  }, [otp, onOtpChange]);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;

    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);
    if (element.value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // Handle backspace
    if (e.key === "Backspace") {
      const newOtp = [...otp];

      if (otp[index] !== "") {
        // If current input has value, clear it
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // If current input is empty, move to previous input and clear it
        newOtp[index - 1] = "";
        setOtp(newOtp);
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain");

    // Extract only digits from pasted data
    const digits = pastedData.replace(/\D/g, "");

    if (digits.length === 0) return;

    const newOtp = [...otp];

    // Fill the OTP inputs starting from the current focused input
    const currentIndex = inputRefs.current.findIndex(
      (input) => input === document.activeElement
    );
    const startIndex = currentIndex >= 0 ? currentIndex : 0;

    for (let i = 0; i < Math.min(digits.length, 6 - startIndex); i++) {
      newOtp[startIndex + i] = digits[i];
    }

    setOtp(newOtp);

    // Focus the next empty input or the last input
    const nextIndex = Math.min(startIndex + digits.length, 5);
    inputRefs.current[nextIndex]?.focus();
  };

  return (
    <div className="otp-input-container">
      <div
        className="otp-inputs"
        style={{ display: "flex", gap: "8px", marginBottom: "20px" }}>
        {otp.map((data, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            maxLength="1"
            value={data}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onFocus={(e) => e.target.select()}
            style={{ border: error ? "1px solid #F44336" : "1px solid #ccc" }}
            className={classes.OTPInput}
          />
        ))}
      </div>
      {error && (
        <p
          className="loginp"
          style={{
            color: "#F44336",
            fontSize: "14px",
            margin: "0 0 10px 0",
            textAlign: "center",
          }}>
          {error}
        </p>
      )}
    </div>
  );
};

export default OTPInput;
